import React from "react";
import { observer } from "mobx-react-lite";
import { useRootStore } from "../../../../store/contexts";
import { ErrorDialog } from "../../../../common/controls";
import { AuthorPublisherListStore } from "../../store/AuthorPublisherListStore";

type AuthorPublisherListDialogsProps = {
  store: AuthorPublisherListStore;
};

/**
 * Componente que agrupa todos los dialogs del listado de AuthorPublisher.
 * Separado para mantener AuthorPublisherListPage más limpio.
 */
export const AuthorPublisherListDialogs: React.FC<AuthorPublisherListDialogsProps> =
  observer(({ store }) => {
    const { langStore } = useRootStore();

    return (
      <>
        {/* Dialog de error genérico */}
        <ErrorDialog
          open={store.errorDialogOpened}
          title={store.errorTitle || langStore.errorTitle}
          description={store.errorDescription}
          onClose={() => store.closeErrorDialog()}
        />
      </>
    );
  });
